/* unplugin-vue-components disabled */
import OutputModal from './output-modal.vue'

export default {
  components: {OutputModal},
  props: {
    promptData: {type: Object, default: undefined},
    datasetData: {type: Object, default: undefined},
    outputData: {type: Object, default: () => ({})},
  },
  computed: {
    input() {
      const output = $utils.object.removeKey(this.outputData, 'updated_at')
      return Object.entries(output).map(([key, value]) => ({name: key, value: value}))
    }
  },
  methods: {
    open(item){
      this.$refs.modal.open(item.value.output)
    }
  }
}
